export type EnvironmentStand = 'dev' | 'test' | 'preprod' | 'prod'

const STANDS_DOMAIN = 'sz.rshbcloud.ru'
const PROD_DOMAIN = 'https://svoevagro.ru'

// Базовые адреса стендов проекта
export const ENVIRONMENT_STANDS: Record<EnvironmentStand, string> = {
  dev: `https://svoevagro-dev.${STANDS_DOMAIN}`,
  test: `https://svoevagro-test.${STANDS_DOMAIN}`,
  preprod: `https://svoevagro-preprod.${STANDS_DOMAIN}`,
  prod: PROD_DOMAIN,
}
